import * as React from "react";
const SvgFiRrPepperAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pepper-alt_svg__a)">
      <path
        fill="#062147"
        d="M19.333 4c-1.404 0-2.765.738-3.666 1.983-.644-.888-1.522-1.512-2.482-1.8.275-1.08.667-1.776.998-2.356l.195-.35a.998.998 0 1 0-1.755-.956l-.177.315c-.389.684-.951 1.672-1.293 3.249a4.67 4.67 0 0 0-2.819 1.698A4.66 4.66 0 0 0 4.667 4 4.67 4.67 0 0 0 0 8.667C0 11.595 2.833 24 8.5 24a4.52 4.52 0 0 0 3.5-1.672A4.52 4.52 0 0 0 15.5 24C21.267 24 24 11.7 24 8.667A4.673 4.673 0 0 0 19.333 4M15.5 22a2.51 2.51 0 0 1-2.159-1.24A1.56 1.56 0 0 0 12 20.003c-.553 0-1.066.29-1.341.759A2.51 2.51 0 0 1 8.5 22C4.924 22 2 11.933 2 8.667A2.67 2.67 0 0 1 4.667 6a2.67 2.67 0 0 1 2.667 2.667c0 1.502.547 4.173 1.361 6.646a1 1 0 1 0 1.899-.625c-.828-2.515-1.261-4.932-1.261-6.021A2.67 2.67 0 0 1 12 6c.789 0 1.575.462 2.103 1.234.355.52.939.833 1.562.833h.002c.623 0 1.208-.311 1.564-.833C17.757 6.46 18.543 6 19.333 6A2.67 2.67 0 0 1 22 8.667C22 11.79 19.229 22 15.5 22"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pepper-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPepperAlt;
